import ActivityIndex from "@/views/directory/activity/ActivityIndex.vue";

const activity = [
    {
        path: '/activities',
        name: 'activity',
        component: ActivityIndex
    }
]

export default activity;